// extracted by mini-css-extract-plugin
export default {"CountriesFeature":"vt_a bhb_b"};